// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dialog-footer[data-v-66ace2e4] {\r\n  text-align: right;\n}\r\n", ""]);
// Exports
module.exports = exports;
